module.exports = __webpack_public_path__ + "img/icon-activity.4e3bc65d.svg";